/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractGuaranteeDto } from './ContractGuaranteeDto';
import {
    ContractGuaranteeDtoFromJSON,
    ContractGuaranteeDtoFromJSONTyped,
    ContractGuaranteeDtoToJSON,
    ContractGuaranteeDtoToJSONTyped,
} from './ContractGuaranteeDto';

/**
 * 
 * @export
 * @interface GetContractGuaranteesResponseDto
 */
export interface GetContractGuaranteesResponseDto {
    /**
     * 
     * @type {Array<ContractGuaranteeDto>}
     * @memberof GetContractGuaranteesResponseDto
     */
    guarantees: Array<ContractGuaranteeDto>;
}

/**
 * Check if a given object implements the GetContractGuaranteesResponseDto interface.
 */
export function instanceOfGetContractGuaranteesResponseDto(value: object): value is GetContractGuaranteesResponseDto {
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    return true;
}

export function GetContractGuaranteesResponseDtoFromJSON(json: any): GetContractGuaranteesResponseDto {
    return GetContractGuaranteesResponseDtoFromJSONTyped(json, false);
}

export function GetContractGuaranteesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractGuaranteesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'guarantees': ((json['guarantees'] as Array<any>).map(ContractGuaranteeDtoFromJSON)),
    };
}

export function GetContractGuaranteesResponseDtoToJSON(json: any): GetContractGuaranteesResponseDto {
    return GetContractGuaranteesResponseDtoToJSONTyped(json, false);
}

export function GetContractGuaranteesResponseDtoToJSONTyped(value?: GetContractGuaranteesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guarantees': ((value['guarantees'] as Array<any>).map(ContractGuaranteeDtoToJSON)),
    };
}

